import React from 'react'
import { observer } from 'mobx-react'
import { Marker } from 'react-native-nmap'
import { locationStore } from 'store/location'
import { USER_LOCATION_MARKER_IMAGE } from 'image'

const USER_LOCATION_MARKER_SIZE = 36

export const UserLocationMarker = observer(() => {
  const location = locationStore._location
  if (!location) return null
  return (
    <Marker
      coordinate={{
        latitude: Number(location.lat),
        longitude: Number(location.lng),
      }}
      width={USER_LOCATION_MARKER_SIZE}
      height={USER_LOCATION_MARKER_SIZE}
      anchor={{ x: 0.5, y: 0.5 }}
      image={USER_LOCATION_MARKER_IMAGE}
    />
  )
})
